import type { ICatalog, ILocalizedText } from '@platform/core/types';
import type { IModuleFlags } from '../../shell/IModuleFlags';
import { recordTypeOrder } from '../../shell/recordTypeOrder';
import type { IModuleRowState } from './IModuleRowState';
import type { IRecordTypeFlags } from './IRecordTypeFlags';
import type { ITypeRow } from './ITypeRow';
import { moduleRank } from './moduleRank';

/**
 * Стан рядків «Встановлених модулів» (прототип v4 cmRows): порядок прототипу для простору, назва (головний тип — назва модуля з каталогу
 * простору, дочірній — назва типу), увімкнення модуля (вимкнений — `disabled` каталогу), обов'язковість (основні й платформні модулі сервер
 * не вимикає), перейменування простору (`localName`), глобальне вимкнення (`globalDisabled`) і перевизначення типів простору (`overridden`
 * типів каталогу). Чиста функція.
 */
export function moduleRowStates(rows: readonly ITypeRow[], catalog: ICatalog | undefined, label: (t: ILocalizedText | null | undefined) => string): IModuleRowState[] {
  const at = recordTypeOrder(catalog, moduleRank());
  return [...rows].sort((a, b) => at(a.rt.key) - at(b.rt.key)).map((row) => {
    const summary = catalog?.modules.find((m) => m.key === row.def.module.key);
    const flags = (summary ?? {}) as IModuleFlags;
    const type = summary?.recordTypes.find((r) => r.key === row.rt.key);
    const typeName = label(type?.name) || label(row.rt.name);
    return {
      row,
      name: row.rt.main ? label(summary?.name) || label(row.def.module.name) : typeName,
      published: row.rt.main ? label(row.def.module.name) : label(row.rt.name),
      enabled: !flags.disabled && !flags.globalDisabled && (summary?.installed ?? true),
      required: row.def.module.core || row.def.module.platformCapability,
      renamed: row.rt.main && !!flags.localName,
      globalOff: !!flags.globalDisabled,
      overridden: !!(type as IRecordTypeFlags | undefined)?.overridden,
      moduleOverridden: !!summary?.recordTypes.some((r) => (r as IRecordTypeFlags).overridden),
    };
  });
}
